import React from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../app/store'
import BasicModalWindow from '../../components/BasicModalWIndow'
import TranscationDetails from './TranscationDetails'
import { useDispatch } from 'react-redux'
import { updateTransactionDetailsModalStatus } from './transactionsSlice'

export default function TransactionDetailsModal() {

    const dispatch = useDispatch()

    const { shown, transaction } = useSelector((state: RootState) => state.transactions.transcationDetailsModal)

    /**
     * Handle close
     */
    const handleClose = () => dispatch(updateTransactionDetailsModalStatus(false))

    return(
        <BasicModalWindow
            shown={shown}
            title="Transaction Details"
            size="sm"
            showHeader
            handleClose={handleClose}
            actionButtons={[
                {
                    label: "Close",
                    handleClose: true,
                    color: "error"
                }
            ]}
        >
            <TranscationDetails {...transaction} />
        </BasicModalWindow>
    )
}